import client from 'api/client'

/**
 * Tracks the completion of the Freemium Upgrade Modal.
 * @param outcome - The outcome of the modal interaction:
 *   - 'continue': User clicked "Save and Continue to Free plan"
 *   - 'upgrade': User clicked "Upgrade"
 *   - 'cancel': User clicked "Close"
 *   - null: User dismissed the modal (clicked outside or pressed close)
 */
export const trackFreemiumModalCompleted = (outcome: 'continue' | 'upgrade' | 'cancel' | null) => {
  return client.trackEvent('Event::FreemiumModalCompleted', {
    outcome,
  })
}
